import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";

export const DEFAULT_FIRM_WORKING_HOURS = {
  start_time: "08:00:00",
  end_time: "17:00:00",
  work_days: [0, 1, 2, 3, 4],
  work_day_names: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
  restrict_to_work_days: false,
  is_configured: false,
  weekday_choices: [
    { value: 0, label: "Monday" },
    { value: 1, label: "Tuesday" },
    { value: 2, label: "Wednesday" },
    { value: 3, label: "Thursday" },
    { value: 4, label: "Friday" },
    { value: 5, label: "Saturday" },
    { value: 6, label: "Sunday" },
  ],
};

const normalizeWorkingHours = (data) => ({
  ...DEFAULT_FIRM_WORKING_HOURS,
  ...(data || {}),
  work_days: Array.isArray(data?.work_days) ? data.work_days : DEFAULT_FIRM_WORKING_HOURS.work_days,
  weekday_choices: Array.isArray(data?.weekday_choices)
    ? data.weekday_choices
    : DEFAULT_FIRM_WORKING_HOURS.weekday_choices,
});

const useFirmWorkingHours = () => {
  const [data, setData] = useState(DEFAULT_FIRM_WORKING_HOURS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchWorkingHours = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api_without_cancellation.get("/api/firmsetting-page/working-hours/");
      const normalized = normalizeWorkingHours(response.data);
      setData(normalized);
      return normalized;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);

  const saveWorkingHours = useCallback(async (values) => {
    setError(null);
    try {
      const response = await api_without_cancellation.patch(
        "/api/firmsetting-page/working-hours/",
        values
      );
      const normalized = normalizeWorkingHours(response.data);
      setData(normalized);
      return normalized;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    }
  }, []);

  useEffect(() => {
    fetchWorkingHours().catch(() => {
      // Consumers keep the legacy defaults available when the request fails.
    });
  }, [fetchWorkingHours]);

  return { data, loading, error, refetch: fetchWorkingHours, saveWorkingHours };
};

export default useFirmWorkingHours;
